/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@mui/styles';
import Tabs from 'apollo-react/components/Tabs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../custom-hooks';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';
import {
  checkActiveContainers,
  handleTabChangeForSelectedSubGrids,
} from '../../actions/runtime.actions';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import DynamicField from '../../DynamicField';
import {
  getEvaluatedDefaultTabIndex,
  getPropByModel,
} from '../../selectors/form-manager.selectors';
import { getFilteredChildrenNodesForTabSet } from '../../selectors/runtime.selectors';
import { equalityFn } from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  root: {
    marginBottom: ({ isMobileDevice }) => (isMobileDevice ? 5 : 10),
    display: 'flex',
  },
});

const SSRuntimeTabSet = ({ childrenNodes, isDetail, index, formKey, id }) => {
  const { isMobileDevice } = useWindowDimensions();
  const classes = useStyles({ isMobileDevice });
  const dispatch = useDispatch();

  const filteredChildrenNodes = useFormSelector(
    getFilteredChildrenNodesForTabSet,
    {
      childrenNodes,
    },
    equalityFn
  );
  const defaultTabIndex = useFormSelector(getEvaluatedDefaultTabIndex, {
    childrenNodes: filteredChildrenNodes,
    childrenProps: ['defaultTab'],
    index,
  });

  const [selectedTab, setSelectedTab] = useState(defaultTabIndex);

  const selectedChildrenNodes =
    useFormSelector(getPropByModel, {
      id: filteredChildrenNodes[selectedTab],
      prop: FORM_MODEL_ATTRIBUTES.CHILDREN_NODES,
    }) ?? [];

  const handleChangeTab = (e, value) => {
    setSelectedTab(value);
  };

  useEffect(() => {
    dispatch(handleTabChangeForSelectedSubGrids(formKey)); // TODO: this might require setTimeout
    dispatch(checkActiveContainers(formKey));
  }, [selectedTab]);

  return (
    <div data-ss-id={id}>
      <Tabs
        value={selectedTab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        className={classes.root}
      >
        {filteredChildrenNodes.map((tabId, i) => (
          <DynamicField key={tabId} id={tabId} isDetail={isDetail} tabIndex={i} index={index} />
        ))}
      </Tabs>
      {selectedChildrenNodes.map((childKey) => (
        <DynamicField key={childKey} id={childKey} isDetail={isDetail} index={index} />
      ))}
    </div>
  );
};

export default SSRuntimeTabSet;
